import { render } from "./BaseSearchableSelect.vue?vue&type=template&id=5dfa879a&scoped=true"
import script from "./BaseSearchableSelect.vue?vue&type=script&lang=js"
export * from "./BaseSearchableSelect.vue?vue&type=script&lang=js"

import "./BaseSearchableSelect.vue?vue&type=style&index=0&id=5dfa879a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dfa879a"]])

export default __exports__